module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/050-mauritania-09d6ae33f6cad45a6e4a4cc3043ef498.svg";